import { FxInputField, FxSelectField } from 'axp-fx-common';
import fields from '../../../constants/fields';
import labels from '../../../constants/labels';

export const contactUpdateFormFields = {
  contactName: {
    id: 'userFullName',
    name: 'userFullName',
    component: FxInputField,
    label: labels.CONTACT_NM,
    isRequired: true,
    className: 'col-md-3',
  },
  countryId: {
    id: fields.countryId,
    name: fields.countryId,
    component: FxSelectField,
    selectOptionFields: {
      id: 'ctryId',
      value: 'ctryId',
      name: 'ctryIntlDialingCd',
    },
    className: 'col-md-4 pad-0-lr',
  },
  phoneNo: {
    id: fields.phoneNumber,
    name: fields.phoneNumber,
    component: FxInputField,
    isRequired: true,
    className: 'col-md-8 pad-0-lr',
  },
  emailAddress: {
    id: 'userEmailId',
    name: 'userEmailId',
    component: FxInputField,
    label: labels.CONTACT_EMAIL,
    className: 'col-md-3',
    toolTipProps: { id: 'userEmailId-info', content: labels.EMAIL_TOOLTIP, placement: 'top' },
  },
  role: {
    id: 'role',
    name: 'role',
    component: FxInputField,
    label: labels.CONTACT_TYPE,
    className: 'col-md-3',
    toolTipProps: { id: 'role-info', content: labels.CONTACT_TYPE_TOOLTIP, placement: 'top' },
  },
};
